import React, { useContext } from 'react';
import { BarrioContext } from './BarrioContext';

// Se muestra en cualquier pantalla del portal del residente cuando
// PersonaResidenteContext resuelve `sinAcceso: true` -- el usuario está
// logueado pero no tiene una unidad funcional asociada vigente en este
// barrio (no asociado, o con fechaHasta vencida). Reemplaza el contenido
// normal de la pantalla en vez de dejarla muda o con una grilla vacía sin
// explicación.
const SinAccesoResidente = () => {
    const { barrio } = useContext(BarrioContext);

    return (
        <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            textAlign: 'center', padding: '4rem 1.5rem', minHeight: '45vh',
        }}>
            <div style={{
                width: 64, height: 64, borderRadius: '50%', background: '#fef3f2',
                display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.25rem',
            }}>
                <i className="pi pi-lock" style={{ fontSize: '1.8rem', color: '#f04438' }} />
            </div>
            <h4 style={{ margin: 0, color: '#101828' }}>No tenés acceso a esta sección</h4>
            <p style={{ maxWidth: 420, margin: '0.75rem 0 0', color: '#667085', fontSize: '0.92rem', lineHeight: 1.5 }}>
                Tu usuario no está asociado a ninguna unidad funcional vigente{barrio?.nombre ? ` en ${barrio.nombre}` : ''}.
                Comunicate con el administrador para que revise tu acceso.
            </p>
        </div>
    );
};

export default SinAccesoResidente;
